const ONES = [
  "",
  "One",
  "Two",
  "Three",
  "Four",
  "Five",
  "Six",
  "Seven",
  "Eight",
  "Nine",
  "Ten",
  "Eleven",
  "Twelve",
  "Thirteen",
  "Fourteen",
  "Fifteen",
  "Sixteen",
  "Seventeen",
  "Eighteen",
  "Nineteen",
];

const TENS = [
  "",
  "",
  "Twenty",
  "Thirty",
  "Forty",
  "Fifty",
  "Sixty",
  "Seventy",
  "Eighty",
  "Ninety",
];

const SCALES = ["", "Thousand", "Million", "Billion"];

const twoDigits = (value) => {
  if (value < 20) return ONES[value];
  const tens = Math.floor(value / 10);
  const ones = value % 10;
  return ones ? `${TENS[tens]}-${ONES[ones]}` : TENS[tens];
};

const hundreds = (value) => {
  const hundred = Math.floor(value / 100);
  const rest = value % 100;
  const parts = [];
  if (hundred) parts.push(`${ONES[hundred]} Hundred`);
  if (rest) parts.push(twoDigits(rest));
  return parts.join(" ");
};

const integerToWords = (value) => {
  if (value === 0) return "Zero";
  const parts = [];
  let scale = 0;
  let remaining = value;
  while (remaining > 0) {
    const chunk = remaining % 1000;
    if (chunk) {
      const words = hundreds(chunk);
      parts.unshift(scale ? `${words} ${SCALES[scale]}` : words);
    }
    remaining = Math.floor(remaining / 1000);
    scale += 1;
  }
  return parts.join(" ");
};

export const centsFromAmount = (amount) => {
  const numeric = Number(amount);
  if (!Number.isFinite(numeric) || numeric < 0) return null;
  return Math.round(numeric * 100);
};

export const amountInWords = (amount) => {
  const totalCents = centsFromAmount(amount);
  if (totalCents === null) return "";
  const dollars = Math.floor(totalCents / 100);
  const cents = totalCents % 100;
  return `${integerToWords(dollars)} and ${String(cents).padStart(2, "0")}/100`;
};

export const formatCheckNumericAmount = (amount) => {
  const totalCents = centsFromAmount(amount);
  if (totalCents === null) return "";
  const dollars = Math.floor(totalCents / 100);
  const cents = totalCents % 100;
  return `${dollars.toLocaleString("en-US")}.${String(cents).padStart(2, "0")}`;
};

export const formatCheckAmount = (amount) => {
  const numeric = formatCheckNumericAmount(amount);
  return numeric ? `$${numeric}` : "";
};

export const formatCheckDate = (value) => {
  if (!value) return "";
  const date = value instanceof Date ? value : new Date(`${value}T00:00:00`);
  if (Number.isNaN(date.getTime())) return "";
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
};
